var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "67px",
    viewBox: "0 0 71 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "symbols/illustrations/meeting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confirmation---Email-Address-Only",
    transform: "translate(-562.000000, -670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(522.000000, 625.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbols/illustrations/email",
    transform: "translate(24.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(45.142857, 60.000000) rotate(-8.000000) translate(-45.142857, -60.000000) translate(18.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.68457143,35.3508571 C5.62171429,35.8194286 23.5274286,35.6937143 27.8217143,35.5708571 C32.796,35.428 52.6217143,34.6622857 52.0388571,34.588",
    id: "Stroke-1",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40171429,2.42114286 C5.11885714,3.18114286 17.8445714,13.8011429 21.7845714,16.4125714 C22.6645714,16.9954286 27.6645714,20.3697143 28.4874286,20.9811429",
    id: "Stroke-3",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5454286,
    y1: 8.33371429,
    x2: 14.6054286,
    y2: 8.33371429,
    id: "Stroke-5",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.364,12.4197143 C19.344,12.4397143 19.324,12.4597143 19.304,12.4797143",
    id: "Stroke-7",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.134,
    y1: 33.8134286,
    x2: 14.9997143,
    y2: 33.8134286,
    id: "Stroke-9",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.9271429,
    y1: 33.5457143,
    x2: 22.9271429,
    y2: 33.68,
    id: "Stroke-11",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0474286,33.4102857 C30.136,33.5988571 30.2217143,33.7731429 30.316,33.9474286",
    id: "Stroke-13",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5542857,28.9768571 C26.4657143,29.0225714 26.3771429,29.0682857 26.2857143,29.1111429",
    id: "Stroke-15",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.6274286,
    y1: 28.9768571,
    x2: 18.6274286,
    y2: 29.1111429,
    id: "Stroke-17",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.4782857,
    y1: 7.73371429,
    x2: 19.4782857,
    y2: 7.788,
    id: "Stroke-19",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17114286,35.8865714 C5.62542857,32.0065714 16.6368571,19.8122857 18.214,18.1065714",
    id: "Stroke-21",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0397143,36.9091429 C49.5854286,33.0291429 37.9711429,19.592 36.394,17.8891429",
    id: "Stroke-23",
    stroke: "#FCEDAE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00914286,2.33457143 C1.21771429,4.31742857 1.552,16.2631429 1.50914286,19.3374286 C1.452,23.4031429 1.48342857,34.8088571 2.08628571,36.9688571 C7.43771429,37.4945714 22.3348571,37.2317143 27.1491429,37.2317143 C33.4091429,37.2317143 45.7034286,36.9888571 52.1548571,36.9288571 C52.452,30.7945714 52.4291429,26.2088571 52.4291429,18.7202857 C52.4291429,15.346 52.8405714,2.88314286 51.9434286,2.04314286 C51.332,1.466 34.3062857,1.65457143 29.8348571,1.60028571 C23.4262857,1.52028571 16.6405714,1.37457143 10.2348571,1.58028571 C7.27485714,1.67457143 2.13485714,1.886 2.00914286,2.33457143 Z",
    id: "Stroke-25",
    stroke: "#F3D139",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00914286,2.33457143 C2.02342857,2.46314286 7.90342857,8.38028571 14.3977143,13.8002857 C19.3234286,17.906 26.1805714,21.8974286 27.0005714,21.8974286 C28.232,21.8974286 34.5777143,18.2545714 39.8605714,13.7345714 C45.292,9.08885714 50.5662857,3.546 51.9434286,2.04314286",
    id: "Stroke-27",
    stroke: "#F3D139",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(54.000000, 17.000000)",
    stroke: "#33447C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7364419,7.51713524 C10.8334324,7.3806019 8.52943238,11.8666971 8.14177524,14.2462781 C7.78581333,16.421059 8.01499429,18.8713448 9.14870857,20.7486781 C10.9992229,23.8084876 14.4149943,25.2713448 17.7966324,24.3497448 C21.344061,23.381821 23.31648,20.3854019 23.4798324,16.1748114 C23.6139276,12.6493257 20.91008,7.66098286 15.7364419,7.51713524 Z",
    id: "Stroke-1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5744305,7.82555429 L23.5744305,21.5715352 C23.5744305,23.28064 24.6569448,24.3582781 25.9101257,24.4484876 C27.1096686,24.533821 27.9166781,23.7975162 28.3555352,23.151421 C32.6904686,16.7733638 31.4958019,6.83081143 24.8910019,2.44224 C21.3191924,0.0675352381 15.7213257,-0.315245714 11.6935924,0.769706667 C7.59271619,1.87416381 0.183344762,5.63126857 0.190653636,16.1077638 C0.195535238,22.4955733 2.67751619,26.8451352 6.39561143,29.42464 C8.8142019,31.1020495 11.6155733,32.3015924 15.550659,31.9383162",
    id: "Stroke-3",
    strokeWidth: 3
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.cf6ce08f90bdcb3226cfdd677e002361.svg";
export { ForwardRef as ReactComponent };